module.exports = __webpack_public_path__ + "static/media/1018020.14123df1.png";